import { useState, useEffect } from 'react';
import { getItems } from '../api/api';

const EMPTY = { lines: [] };
const localStorageEnabled = (() => {
	try {
		window.localStorage.setItem('__test', '1');
		const works = window.localStorage.getItem('__test') === '1';
		window.localStorage.removeItem('__test');
		return works;
	} catch(err) {
		console.warn('LocalStorage not available');
		return false;
	}
})();

async function getInitialCart(customer, catalog) {
	if(!localStorageEnabled) {
		return EMPTY;
	}
	try {
		const parsed = JSON.parse(window.localStorage.getItem('cart'));
		if(!parsed || !Array.isArray(parsed.lines)) {
			return EMPTY;
		}
		const bySku = {};
		if(parsed.lines.some(line => {
			if(typeof line.item === 'object' && typeof line.quantity === 'number') {
				bySku[line.item.sku] = line;
				return false;
			}
			return true;
		})) {
			return EMPTY;
		}
		const skus = Object.keys(bySku);
		if(skus.length) {
			const items = await getItems(customer, catalog, skus);
			items.forEach(item => {
				bySku[item.sku].item = item;
				delete bySku[item.sku];
			});
			parsed.lines = parsed.lines.filter(line => !bySku[line.item.sku]);
			return parsed;
		}
	} catch(err) {
		//invalid or empty cart
	}
	return EMPTY;
}

function saveCart(cart) {
	if(localStorageEnabled) {
		window.localStorage.setItem('cart', JSON.stringify(cart));
	}
}

export default function useCart(customer, catalog) {
	const [cart, setCart] = useState(null);
	useEffect(() => {
		if(customer && catalog) {
			getInitialCart(customer, catalog).then(setCart).catch(err => {
				console.warn('Failed to get cart', err);
			});
		}
	}, [customer, catalog]);
	useEffect(() => {
		if(cart) {
			saveCart(cart);
		}
	}, [cart]);
	const setCartItem = (item, quantity) => {
		setCart(c => {
			const clone = Object.assign({}, c);
			if(quantity <= 0) {
				clone.lines = clone.lines.filter(line => line.item.sku !== item.sku);
			} else {
				const index = clone.lines.findIndex(line => line.item.sku === item.sku);
				if(index >= 0) {
					clone.lines = clone.lines.slice();
					clone.lines[0].quantity = quantity;
				} else {
					clone.lines = clone.lines.concat({ item, quantity });
				}
			}
			return clone;
		});
	};
	const clearCart = () => setCart(EMPTY);
	return { cart: cart || EMPTY, setCartItem, clearCart };
}
